import React,
{
	useRef,
	useState,
	useEffect
}
	from "react"
import StagingBanner
	from "./components/stagingBanner"
import {
Route,
Routes,
Navigate,
Link,
useLocation,
useNavigate
}
	from "react-router-dom"
import Modal
	from "react-modal"
import {
useSelector,
useDispatch
}
	from "react-redux"
import { Popover }
	from "react-tiny-popover"
import { FontAwesomeIcon }
	from "@fortawesome/react-fontawesome"
import {
solid,
regular
}
	from "@fortawesome/fontawesome-svg-core/import.macro"
import _
	from "lodash"

import
store, {
	RootState,

	displayNotice,
	dismissNotice,

	enableIdleLockSwitch,
	disableIdleLockSwitch,

	setSessionToken,
	setAuthenticated,
	toggleTheme,
	setUserProfile,
	setCurrentUserRole,
	setCurrentUserCampus,
	setCurrentUserCampusId,
	setCampusRef,

	setUserMenu,
	setMenuRef,
	setNavigation
}
	from "./globals"
import useClickOutsideRef,
{
	themes,
	UIState,
	baseNavigation,
	basicSetup,
	baseMenu,
	isNotEmpty,
	generateSectionMap
}
	from "./common"
import AuthService
	from "./services/auth.service"
import CustomIcon
	from "./components/customIcon"
import { UserPrompt }
	from "./components/sectionContainer"
import Access
	from "./navigation/access"
import {avatarPorDefecto}
	from "./utils/avatarPorDefecto"
import logoMenu
	from "./assets/images/logoMenu.png"
/*
	El lockup de Washington Academy lleva aguila roja y letrero azul marino: sobre
	la barra lateral oscura el azul se pierde y el conjunto se ve sucio. El kit de
	marca trae la version blanca justo para eso, asi que en modo oscuro se usa esa.
	(Esteban, 2026-09-20)
*/
import logoMenuBlanco
	from "./assets/images/logoMenuBlanco.png"
import {plantelMedio, plantelSiglas}
	from "./utils/plantelCorto"
import wappWordmark
	from "./assets/images/wappWordmarkNaranja.svg"

import "./style.css"
import "./assets/css/app.css"
import { tunning } from "./constants"
import {
	setCurrentCampusId,
	setCurrentRole,
	setAllowedCampuses,
	setCurrentCampus,
	setUser,
	UserState,
	setPermissions,
	handleLogout
} from "./redux/reducers/sessionReducer";
import HttpManager from "./services/HttpManager"
import { setPaymentMethods } from "./redux/reducers/catalogReducer"
import { useAxiosInterceptor } from "./services/v2/axiosInstance"
import { ReactNode } from "react"
import { version } from "./version"
import { borrarSesionLocal } from "./guardiaDeSesion"


const PrivateRoute = ({ authenticated, children }: { authenticated: boolean; children: any }) => {
	if (!authenticated) {
		return <Navigate to="/access" replace />
	}

	return children
}

const Accordion =
	(
		{ block, content, currentRoute }: { block: any; content: { display: string; route: string; under?: string | null }[]; currentRoute: string }
	) => {
		const [isActive, setIsActive] = useState(false)
		const icons: any = [solid("chevron-up"), solid("chevron-down")]
		const menuRef: any = useSelector((state: RootState) => state.menuRef.value)
		const idleLocked: boolean = useSelector((state: RootState) => state.idleLockSwitch.value)

		return <tbody>
			<tr onClick={() => setIsActive(!isActive)} style={{ background: "var(--wa-superficie)", color: "var(--wa-tinta)", cursor: "pointer" }}>
				<td style={{ width: "74px", textAlign: "center", paddingLeft: "30px", color: "var(--wa-apagado)" }} className="xsDisposable">
					<CustomIcon name={block.icon} style={{ fill: (menuRef[currentRoute] != block.group ? "var(--wa-apagado)" : "var(--wa-acento)") }} />
				</td>
				<td style={{ padding: "10px 0px 10px 4px", color: (menuRef[currentRoute] != block.group ? "var(--wa-apagado)" : "var(--wa-acento)") }}><b>
					{block.display}
				</b></td>
				<td className="xsDisposable" style={{ textAlign: "right", paddingRight: "34px" }}>
					<FontAwesomeIcon icon={icons[+isActive]} />
				</td>
			</tr>
			{
				!isActive ? "" : content.map
					(
						({ display, route, under }: { display: string; route: string; under?: string | null }) => <tr key={block.display + "." + display}
							style={{ background: (route == currentRoute ? "var(--wa-acento-suave)" : "var(--wa-superficie)"),
								color: (route == currentRoute ? "var(--wa-acento)" : "var(--wa-apagado)"),
								fontWeight: (route == currentRoute ? 800 : 500),
								boxShadow: (route == currentRoute ? "inset 3px 0 0 var(--wa-acento)" : "none") }}
						>
							<td style={{ textAlign: "right", paddingRight: "5px" }} className="xsDisposable" />
							{/* Las secciones que cuelgan de otra salen indentadas (Esteban, 2026-09-22). */}
							<td colSpan={2} style={{ padding: "5px 20px 5px " + (under ? 26 : 8) + "px" }}>{
								idleLocked
									?
									<div style={{ fontWeight: route == currentRoute ? "500" : "300" }}>
										{display}
									</div>
									:
									<Link to={route}>
										<div style={{ fontWeight: route == currentRoute ? "500" : "300" }}>
											{display}
										</div>
									</Link>
							}</td>
						</tr>
					)
			}
		</tbody>
	}

const App = () => {
	useAxiosInterceptor();

	const http = HttpManager.getInstance();
	const dispatch: any = useDispatch()
	const navigate: any = useNavigate()
	const currentCampusId: number = useSelector((state: RootState) => state.rootReducer.sessionState.currentCampusId);
	const userData: UserState | null = useSelector((state: RootState) => state.rootReducer.sessionState.user);
	const allowedCampuses: any[] = useSelector((state: RootState) => state.rootReducer.sessionState.allowedCampuses);
	const currentCampus: any = useSelector((state: RootState) => state.rootReducer.sessionState.currentCampus);
	const campuses: any[] = useSelector((state: RootState) => state.rootReducer.catalog.campuses);
	const roles: any[] = useSelector((state: RootState) => state.rootReducer.sessionState.roles);
	const currentRole = useSelector((state: RootState) => state.rootReducer.sessionState.currentRole);

	const userProfile: any = useSelector((state: RootState) => state.userProfile.value)
	const currentUserCampus: any = useSelector((state: RootState) => state.currentUserCampus.value)
	const campusRef: any = useSelector((state: RootState) => state.campusRef.value)
	const sessionToken: string | null = useSelector((state: RootState) => state.sessionToken.value)
	const authenticated: boolean = useSelector((state: RootState) => state.authenticated.value)
	const userMenu: any = useSelector((state: RootState) => state.userMenu.value)
	const navigation: any = useSelector((state: RootState) => state.navigation.value)
	const basicInfo: any = useSelector((state: RootState) => state.basicInfo.value)
	const location: string = useLocation().pathname.substr(1)
	const idleLocked: boolean = useSelector((state: RootState) => state.idleLockSwitch.value)
	//const [themeToggle, setThemeToggle] = useState(useSelector((state : RootState) => state.themeToggle.value));
	const [unfilledFields, setUnfilledFields] = useState<boolean>(false)
	const [noCityProvided, setNoCityProvided] = useState<boolean>(false)
	const [campusesListShown, setCampusesListShown] = useState<boolean>(false)
	const [appLoaded, loadApp] = useState<boolean>(false)
	const [UIStatus, setUIStatus] = useState<number>(UIState.NORMAL)
	const [saveError, setSaveError] = useState<any>(null)
	const [roleListShown, roleListDisplay] = useState<boolean>(false)
	const [userProfileOptionsShown, setUserProfileOptionsShown] = useState<boolean>(false)
	const [selectedUserProfile, setSelectedUserProfile] = useState<any>(null)
	const [editableUserProfile, setEditableUserProfile] = useState<any>(null)
	const [saveSuccess, setSaveSuccess] = useState<boolean>(false)

	let formRef = useRef<HTMLFormElement>(null)

	const fetchPaymentMethods = async () => {
		try {
			const response = await http.paymentMethodService.getPaymentMethodsByCountry(currentCampus.countryId);
			dispatch(setPaymentMethods(response.data));
		} catch (err: any) {
			console.error(err);
		}
	}

	const handleCampusChange = (campus: any) => {
		dispatch(setCurrentUserCampus(campus.refIndex));
		dispatch(setCurrentUserCampusId(campus.id));
		const campusId = campus.id;
		dispatch(setCurrentCampusId(campusId));
		const newCampus = campuses.find((campus: any) => campus.id === campusId);
		dispatch(setCurrentCampus(newCampus));
	}

	useEffect(() => {
		if (currentCampus && userData && userData.token) {
			fetchPaymentMethods();
		}
	}, [currentCampusId]);

	/*
		UN SOLO PLANTEL ACTUAL.

		WAPP llevaba dos: el de la barra de arriba (currentUserCampus, el que la
		persona ve y cambia) y el de sessionState, que se guarda en el navegador.
		Casi todas las pantallas de dinero —Pagos, Facturas, Creditos, Estado de
		cuenta, Tablero— leen el segundo, que no se ve en ninguna parte.

		Se separaban solos por tres caminos distintos: al restaurar sesion (ya
		corregido arriba), al iniciar sesion —cada uno se fija desde una fuente
		distinta— y al abrir un enlace directo de Horarios, que mueve la barra y
		no el otro. El sintoma no parecia un problema de plantel: a una alumna de
		San Pedro Sula con 24,000.00 de saldo el estado de cuenta le salia en 0.00
		y en pesos, porque preguntaba por ella en Torreon. (Esteban, 2026-09-19)

		En vez de perseguir cada camino, el de sessionState SIGUE al de la barra,
		siempre. Nadie lo mueve a proposito por su cuenta —se reviso uno por uno—,
		asi que la barra manda y esto no le quita el control a nadie.

		No entra en bucle: al terminar los dos coinciden y la guardia de abajo
		corta. Si el catalogo aun no llego, no hace nada y se reintenta cuando
		llegue.
	*/
	useEffect(() => {
		if (!userData || !userData.token) {
			return
		}

		if (!Array.isArray(campuses) || campuses.length < 1) {
			return
		}

		const plantelDeLaBarra: number | null = campusRef?.[currentUserCampus]?.id ?? null

		if (plantelDeLaBarra == null) {
			return
		}

		if (currentCampus?.id === plantelDeLaBarra && currentCampusId === plantelDeLaBarra) {
			return
		}

		const plantel: any = campuses.find((registro: any) => registro.id === plantelDeLaBarra)

		if (plantel == null) {
			return
		}

		dispatch(setCurrentCampusId(plantelDeLaBarra))
		dispatch(setCurrentCampus(plantel))
	}, [currentUserCampus, campusRef, campuses, currentCampus, currentCampusId, userData])

	/*
		El plantel de la barra se guarda en el navegador cada vez que cambia. Antes solo lo guardaban
		unas pantallas viejas (Calendario, Salones), así que cambiar de plantel en la barra y recargar
		regresaba al último que esas guardaron: "estaba en TGU, refresqué y me mandó a SPS"
		(Esteban, 2026-09-24). Solo se guarda un plantel que la persona tiene; vacío no borra nada.
	*/
	useEffect(() => {
		if (!currentUserCampus || !campusRef?.[currentUserCampus]) {
			return
		}

		try {
			localStorage.setItem("currentCampus", currentUserCampus)
		}
		catch (e) {
			//Sin almacenamiento (modo privado): no pasa nada, solo no se recuerda.
		}
	}, [currentUserCampus, campusRef])

	const logout = () => {
		dispatch(handleLogout());
		localStorage.removeItem("persist:root");
		AuthService
			.logout(sessionToken)
			.then
			(
				() => {
					let menu = baseMenu
					let menuMap = []

					localStorage.clear()
					dispatch(setUserProfile(null))
					dispatch(setCurrentUserCampus(null))
					dispatch(setCurrentUserCampusId(null))
					dispatch(setCampusRef(null))
					dispatch(setSessionToken(null))
					dispatch(setAuthenticated(false))
					dispatch(setUser(null));

					menu?.forEach
						(
							(element: any, index: number) => {
								element.sections.forEach
									(
										(item: any, subIndex: number) => {
											menuMap[item.route] = element.block.group
										}
									)
							}
						)

					dispatch(setUserMenu(baseMenu))
					dispatch(setMenuRef(null))
					dispatch(setNavigation(baseNavigation))
					navigate("/access")
					window.location.reload()
				},
				(error: any) => {
					//Si el servidor ya no reconoce la sesión (401), la guardia de sesión se encarga.
					//Cualquier otro fallo (red caída) igual cierra en este equipo: el token se borra
					//y se recarga limpio. Antes se quedaba el token muerto guardado y la persona
					//rebotaba entre el error y el login (2026-09-29).
					if (error?.response?.status !== 401) {
						borrarSesionLocal()
						window.location.replace("/access")
					}
				}
			)
			.finally(() => dispatch(disableIdleLockSwitch()))
	}

	const fetchRoleData = async () => {
		if (!currentRole || !userProfile) {
			return null;
		}
		try {
			dispatch(enableIdleLockSwitch());
			const response = await http.roleService.updateActiveRole(userProfile.id, currentRole.id);
			dispatch(setPermissions(response.data.permissions));
			return response.data;
		} catch (err: any) {
			console.error("Error al obtener datos del rol:", err);
			dispatch(
				displayNotice({
					heading: <h3 style={{ color: "var(--wa-rojo-error)", display: "inline-block" }}>Error</h3>,
					message: "No se pudieron cargar los permisos del rol actual",
					cornerClose: false
				})
			);
		} finally {
			dispatch(disableIdleLockSwitch());
		}
	};

	useEffect(() => {
		const loadRoleData = async () => {
			await fetchRoleData();

			const roleJustChanged = localStorage.getItem("roleJustChanged");
			if (roleJustChanged === "true") {
				localStorage.removeItem("roleJustChanged");
				window.location.reload();
			}
		};

		loadRoleData();
	}, [currentRole, userProfile]);

	const onLoad = async () => {
		let menuMap: any = {}
		let assignedNavigation: any
		let menu: any

		dispatch(enableIdleLockSwitch())

		try {
			const accessToken: any = localStorage.getItem("accessToken")

			if (accessToken?.trim()) {
				dispatch(setSessionToken(accessToken))

				const result: any = await AuthService.getInitData()
				let user: any = result.data.user
				let campuses: any = result.data.campuses
				let campusIndex: any = {}
				const currentRole: string | null = localStorage.getItem("currentRole")
				user.currentCampus = localStorage.getItem("currentCampus")

				if (currentRole == null) {
					if (user.roles.length > 0) {
						user.currentRole = user.initialRole.code
					}
					else {
						if (user.student) {
							user.currentRole = "student"
						}
					}
				}
				else {
					if ((currentRole == "student" && user.student) || (user.roles.length > 0 && user.roleMap[currentRole])) {
						user.currentRole = currentRole
					}
					else {
						localStorage.removeItem("currentRole")
					}
				}

				if (user.currentRole) {
					dispatch(setCurrentUserRole(user.currentRole))
					localStorage.setItem("currentRole", user.currentRole)
				}

				let refIndex: string

				if (user.currentRole == "student") {
					menu = baseMenu
					assignedNavigation = baseNavigation

					user.student.campuses.map
						(
							(campus: any) => {
								refIndex = "C_" + campus.id
								campusIndex[refIndex] = { ...campus, refIndex: refIndex }

								return
							}
						)

					user.student.campusRef = campusIndex
				}
				else {
					if (user.roleMap[user.currentRole].campuses && user.roleMap[user.currentRole].campuses.length > 0) {
						dispatch(setAllowedCampuses(user.roleMap[user.currentRole].campuses));
						user.roleMap[user.currentRole].campuses.map
							(
								(campus: any) => {
									refIndex = "C_" + campus.id
									campusIndex[refIndex] = { ...campus, refIndex: refIndex }

									return
								}
							)
					}

					if (user.roleMap[user.currentRole].campuses.length > 0) {
						if (user.currentCampus == null || campusIndex[user.currentCampus] == null) {
							user.currentCampus = "C_" + user.roleMap[user.currentRole].campuses[0].id
							dispatch(setCurrentCampusId(user.roleMap[user.currentRole].campuses[0].id));
						}
					}
					else {
						if (user.currentCampus) {
							user.currentCampus = null
						}
					}

					if (user.currentCampus) {
						localStorage.setItem("currentCampus", user.currentCampus)
						/*
							Aqui iba campuses[0].id, o sea SIEMPRE el primer plantel del rol,
							aunque la persona tuviera otro escogido. De ahi salia que la barra
							dijera "San Pedro Sula" y las pantallas de dinero preguntaran por
							Torreon. Se fija el plantel que de verdad esta escogido.
							(Esteban, 2026-09-19)
						*/
						dispatch(setCurrentCampusId(campusIndex[user.currentCampus].id));
					}
					else {
						if (localStorage.getItem("currentCampus")) {
							localStorage.removeItem("currentCampus")
						}
					}

					const [complementaryMenu, complementaryNavigation] = generateSectionMap(user)
					menu = [...baseMenu, ...complementaryMenu]
					assignedNavigation = [...baseNavigation, ...complementaryNavigation]
				}

				dispatch(setCurrentUserCampusId(user.currentCampus ? campusIndex[user.currentCampus].id : null))
				dispatch(setCampusRef({ ...campusIndex }))
				dispatch(setCurrentUserCampus(user.currentCampus))
				basicSetup(result.data, dispatch)
			}
			else {
				menu = baseMenu
				assignedNavigation = baseNavigation
			}
		}
		catch (error) {
			menu = baseMenu
			assignedNavigation = baseNavigation

			console.log(error)
			localStorage.clear()
		}
		finally {
			loadApp(true)
			dispatch(disableIdleLockSwitch())

			menu?.forEach
				(
					(element: any, index: number) => {
						element.sections.forEach
							(
								(item: any, subIndex: number) => {
									menuMap[item.route] = element.block.group
								}
							)
					}
				)

			dispatch(setUserMenu(menu))
			dispatch(setMenuRef(menuMap))
			dispatch(setNavigation(assignedNavigation))
		}
	}

	useEffect(() => { onLoad() }, [])

	const saveUserProfile = async () => {
		if (formRef && formRef.current) {
			if (!formRef.current.checkValidity()) {
				setUnfilledFields(true)
				formRef.current.reportValidity()

				setTimeout
					(
						() => {
							setUnfilledFields(false)
						},
						3000
					)
			}
			else {
				if
					(
					(
						basicInfo.countryRef["C_" + editableUserProfile.country_id].states.length > 0 &&
						basicInfo.countryRef["C_" + editableUserProfile.country_id].stateRef["S_" + editableUserProfile.state_id].cities.length > 0
					)
					&&
					(editableUserProfile.city == null || editableUserProfile.city.id == null)
				) {
					setUnfilledFields(true)
					setNoCityProvided(true)

					setTimeout
						(
							() => {
								setUnfilledFields(false)
								setNoCityProvided(false)
							},
							3000
						)
				}
				else {
					if (sessionToken) {
						dispatch(enableIdleLockSwitch());

						try {
							const result = await AuthService.saveCurrentUser(editableUserProfile)
							setUIStatus(UIState.LOCKED)

							if (result.status == 200 || result.status == 204) {
								setSaveSuccess(true)
								setUIStatus(UIState.SUCCESS)

								if (saveError != null) {
									setSaveError(null)
								}

								setTimeout
									(
										() => {
											dispatch
												(setUserProfile({ ...editableUserProfile, image: result.data.image }))
											setSelectedUserProfile(null)
											setEditableUserProfile(null)
											setSaveSuccess(false)
											setUIStatus(UIState.NORMAL)
										},
										tunning.MODAL_DISMISS_DELAY
									)
							}
							else {
								setSaveError
									(
										result.status == 409
											?
											"Hay conflictos en la información proporcionada (correo electrónico, código de identificación). " +
											"Revise que los valores sean únicos en comparación con los registros existentes (alumnos, empleados)"
											:
											"La información no pudo ser guardada"
									)
								setUIStatus(UIState.ERROR)
							}
						}
						catch (error: any) {
							console.log(error)
							setSaveError
								(
									error.response.status != 409 ? "La información no pudo ser guardada" : "Hay conflictos en la información proporcionada " +
										"(" + (error.response.data.message == "duplicate_email_info" ? "correo electrónico" : "código de identificación") + "). " +
										"Revise que los valores sean únicos en comparación con los registros existentes (alumnos, empleados)"
								)
							setUIStatus(UIState.ERROR)
						}
						finally {
							dispatch(disableIdleLockSwitch())
						}
					}
				}
			}
		}
	}

	const themeToggle: boolean = useSelector((state: RootState) => state.themeToggle.value)

	const commonNotice:
		{ heading: ReactNode | null; message: string | null; procedure?: any; optOutProcedure?: any; cornerClose?: boolean } =
		useSelector((state: RootState) => state.commonNotice)

	const icons =
		[
			regular("moon"),
			solid("sun")
		];

	const modeSettings =
		[
			{
				id: "light",
				name: "Light",
				background: "lightBackground",
				class: "theme-mode-light"
			},
			{
				id: "dark",
				name: "Dark",
				background: "dark-background",
				class: "theme-mode-dark"
			}
		];

	const themeSetting = () => {
		const toggle = !themeToggle
		const mode = modeSettings[+!themeToggle]

		localStorage.setItem("themeMode", mode.class)
		dispatch(toggleTheme())
	};

	/*
		El tema tambien se marca en <html>. Hasta ahora la clase vivia en un div de
		adentro de #root, y todo lo que React saca por un portal (los modales, los
		globos de react-tiny-popover, los avisos) cuelga de <body>: quedaba FUERA
		de esa clase y resolvia las variables --wa-* con los valores CLAROS. El
		resultado era una ventana blanca encima de la app oscura. Desde <html>
		alcanza a todo, incluida la franja de rebote del navegador.
		(Esteban, 2026-09-20)
	*/
	useEffect
	(
		() =>
		{
			const raiz = document.documentElement

			raiz.classList.remove("theme-mode-light", "theme-mode-dark")
			raiz.classList.add(modeSettings[+themeToggle].class)
		},
		[themeToggle]
	)

	const toggleRoleListDisplay = () => {
		roleListDisplay(!roleListShown)
	}

	const changeRole = (roleCode: string) => {
		if (currentRole?.code !== roleCode) {
			localStorage.setItem("currentRole", roleCode);
			localStorage.setItem("roleJustChanged", "true");
			dispatch(setCurrentRole(roles.find((r: any) => r.code === roleCode)));
		}
	}

	const showUserProfile = (recordData: any) => {
		let links: any = isNotEmpty(recordData.links) ? JSON.parse(recordData.links) : {}

		Object.keys(links).map((key: string) => links[key] = links[key] || "")
		setUIStatus(UIState.NORMAL)
		setSaveError(null)
		setSelectedUserProfile
			({
				...links, ...recordData, city: { ...recordData.city, label: recordData.city.name },
				zipcode: recordData.zipcode || "",
				imagePreview: recordData.image,
			})
	}

	const MenuDivRef: any = useRef<HTMLDivElement>(null)
	const menuToggleRef: any = useRef<HTMLButtonElement>(null)

	useClickOutsideRef(MenuDivRef, menuToggleRef)

	const setActiveMenu = () => MenuDivRef?.current?.classList?.add("active")
	const closeMenu = () => MenuDivRef?.current?.classList?.remove("active")

	return (!appLoaded || userMenu == null || navigation == null) ? <></> : <>
		<StagingBanner />
		{/* El tema pinta desde aqui: todo lo de adentro hereda las variables --wa-*.
		    Antes el fondo venia de --second-bg, que en oscuro era un gris plano; ahora
		    es el papel del tema, que en oscuro es negro calido. (Esteban, 2026-09-20) */}
		<div className={themes[+themeToggle]} style={{ color: "var(--wa-tinta)" }}><div
			style={{ background: "var(--wa-papel-2)", minHeight: "100vh" }}
		>
			{
				!authenticated ? "" : <div>
					<div className="topNav" style={{ display: (location == "access" ? "none" : "") }}>
						{/* La marca del producto va centrada en la barra. Va absoluta para que
						    no empuje ni el nombre del plantel ni el bloque del usuario, y
						    lleva al Panel, igual que al entrar. Mientras la app esta ocupada
						    se queda sin enlace, como el resto de la navegacion. */}
						<div className="topNavBrand">
							{
								idleLocked
									?
									<img src={wappWordmark} alt="WAPP" />
									:
									<Link to="/" title="Ir al Panel" aria-label="Ir al Panel">
										<img src={wappWordmark} alt="WAPP" />
									</Link>
							}
						</div>
						<div className="topnavRightItem" style={{ flexGrow: 1 }}>
							<div style={{ display: "flex", justifyContent: "left", alignItems: "center", padding: "4px 10px 4px 15px" }}>
								<button ref={menuToggleRef} className="dropdownToggle" onClick={setActiveMenu}
									type="button" style={{ paddingTop: "0px" }}
								>
									<FontAwesomeIcon icon={solid("bars")} style={{ color: "var(--wa-acento)" }} size="2x" />
								</button>
								{
									currentUserCampus == null ? "" :
										(
											Object.keys(campusRef).length < 2
												?
												<>
													<Popover isOpen={campusesListShown} onClickOutside={() => setCampusesListShown(false)}
														positions={["bottom"]} content=
														{<div style={{ padding: "10px 5px", minWidth: "250px", background: "var(--main-bg)", left: "43px" }}>
															<div style={{ padding: "10px 5px" }}>
																<div className="d-sm-table-cell d-sm-none d-md-none d-lg-none d-xl-none">
																	<FontAwesomeIcon
																		icon={solid("check-circle")}
																		style={{ marginLeft: "7px" }}
																	/>
																	<span style={{ paddingLeft: "7px" }}>
																		{campusRef[currentUserCampus].name}
																	</span>
																</div>
															</div>
														</div>}
													><button style={{ color: "var(--wa-acento)", display: "inline-flex", paddingTop: "0px" }} disabled={idleLocked}
														className="btn d-sm-table-cell d-sm-none d-md-none d-lg-none d-xl-none" type="button"
														onClick={() => setCampusesListShown(!campusesListShown)}
													>
															<FontAwesomeIcon icon={solid("school-flag")}
																style={{ marginLeft: "7px" }}
															/>
															<FontAwesomeIcon icon={solid("caret-down")}
																style={{ marginLeft: "7px" }}
															/>
														</button></Popover>
													{/* El nombre no se recorta a la mitad ("Washington Academy Mo" no
													    dice nada): se abrevia. Completo cuando cabe, "WA Monterrey"
													    cuando aprieta, y las siglas del plantel en telefono.
													    (Esteban, 2026-09-16) */}
													<span className="topNavPlantel">
														<span className="plantelLargo">{campusRef[currentUserCampus].name}</span>
														<span className="plantelMedio">{plantelMedio(campusRef[currentUserCampus].name)}</span>
														<span className="plantelSiglas">{plantelSiglas(campusRef[currentUserCampus].name)}</span>
													</span>
												</>
												:
												<Popover onClickOutside={() => setCampusesListShown(false)} isOpen={campusesListShown}
													positions={["bottom"]} content=
													{<div style={{ padding: "10px 5px", minWidth: "250px", background: "var(--main-bg)", left: "43px" }}>
														<div className="d-sm-table-cell d-sm-none d-md-none d-lg-none d-xl-none"
															style={{ paddingBottom: "10px" }}
														>
															<FontAwesomeIcon icon={solid("check-circle")} style={{ marginLeft: "7px" }} />
															<span style={{ paddingLeft: "7px" }}>
																{campusRef[currentUserCampus].name}
															</span>
														</div>
														<fieldset style={{ padding: "5px 10px 0px" }}>
															<legend style={{ position: "relative", bottom: "10px" }}><label
																style={{ background: "var(--main-bg)" }}
															>
																Seleccione otro plantel
															</label></legend>
															{
																Object.values(campusRef).map
																	(
																		(campus: any) => {
																			if (currentUserCampus != campus.refIndex) {
																				return <button style={{ width: "100%", textAlign: "left" }}
																					onClick={() => handleCampusChange(campus)}
																					className="btn btn-default" key={"CA_" + campus.id}
																					disabled={idleLocked}
																				>
																					{campus.name}
																				</button>
																			}
																		}
																	)
															}
														</fieldset>
													</div>}
												><button onClick={() => setCampusesListShown(!campusesListShown)} disabled={idleLocked}
													type="button" className="btn" style={{ padding: "0px 8px", marginLeft: "8px" }}
												><span className="topNavPlantelCaja">
															{/* Antes en telefono salia un iconito de bandera que no decia de
															    que plantel se trataba. Ahora sale el nombre abreviado.

															    Esto colgaba de un display:table-row con un top:3px encima: el
															    nombre y la flecha quedaban en celdas distintas alineadas por
															    linea base, y el texto salia mas arriba que el resto de la
															    barra. Ahora es una fila flex centrada, que alinea igual con
															    cualquier texto y a cualquier ancho. (Esteban, 2026-09-16) */}
															<span className="topNavPlantel">
																<span className="plantelLargo">{campusRef[currentUserCampus].name}</span>
																<span className="plantelMedio">{plantelMedio(campusRef[currentUserCampus].name)}</span>
																<span className="plantelSiglas">{plantelSiglas(campusRef[currentUserCampus].name)}</span>
															</span>
															<FontAwesomeIcon icon={solid("caret-down")} />
														</span></button></Popover>
										)
								}
								<div ref={MenuDivRef} className="themeMenu">
									{/* El lockup va entero, de una sola pieza: el kit de marca no se
									    parte en aguila + letrero por separado. */}
									<div style={{ padding: "25px 30px 25px 20px", height: "113px", display: "flex", alignItems: "center" }}>
										<img src={themeToggle ? logoMenuBlanco : logoMenu} alt="Washington Academy"
											style={{ width: "100%", maxHeight: "63px", objectFit: "contain" }} />
									</div>
									<div style={{ height: "calc(100vh - 175px)", overflowY: "auto" }}><table id="sideMenu"
										style={{ width: "100%" }}
									>{
											userMenu.map
												(
													(path: any, index: number) => <Accordion currentRoute={location} block={path.block}
														content={path.sections} key={index}
													/>
												)
										}</table></div>
									<table style={{ position: "absolute", bottom: "0px", width: "100%" }}><tbody><tr>
										{/* Era un circulito oscuro de 30px sin etiqueta al fondo del menu: nadie lo
										    encontraba. Ahora dice lo que hace. (Esteban, 2026-09-20) */}
										<td style={{ background: "var(--wa-superficie)", borderTop: "1.5px solid var(--wa-filo)", padding: "0px 8px 0px 18px", whiteSpace: "nowrap" }}>
											<button
												style={{
													background: "none", border: "0px", display: "inline-flex", alignItems: "center",
													gap: "10px", height: "62px", padding: "0px", color: "var(--wa-apagado)", cursor: "pointer"
												}}
												onClick={themeSetting}
												type="button"
												title={themeToggle ? "Cambiar a modo claro" : "Cambiar a modo oscuro"}
											>
												<FontAwesomeIcon icon={icons[+themeToggle]} size="lg" />
												<span style={{ fontSize: "14px", fontWeight: 500 }}>
													{themeToggle ? "Modo claro" : "Modo oscuro"}
												</span>
											</button>
										</td>
										<td style={{ background: "var(--wa-superficie)", borderTop: "1.5px solid var(--wa-filo)", textAlign: "center", width: "100%" }}><button
											style={{ height: "62px", color: "var(--wa-apagado)" }} className="themeMenuClose" type="button"
											onClick={closeMenu}
										>
											<FontAwesomeIcon size="xs" style={{ position: "relative", bottom: "5px" }}
												icon={solid("chevron-left")}
											/>
										</button></td>
									</tr></tbody></table>
								</div>
							</div>
						</div>
						<div className="topNavRight">
							<div>
								<p className="topnavRightItem" style={{ padding: "0px", margin: "0px", color: "var(--wa-acento-texto)" }}>
									<b>{userProfile.first_name}</b>
								</p>
							</div>
							<div className="topnavRightItem" style={{ padding: "0px 15px 0px 0px" }}>
							</div>
							<div className="topnavRightItem" style={{ display: "flex", alignItems: "center" }}><Popover positions={["bottom"]}
								onClickOutside={() => setUserProfileOptionsShown(false)} isOpen={userProfileOptionsShown}
								reposition={false} content=
								{<div className="card" style=
									{{ background: "var(--main-bg)", padding: "5px 5px 0px", position: "absolute", right: "0px", width: "250px" }}
								>
									<div className="dropdownFooter">
										Usuario
									</div>
									<div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
										<div style={{ position: "relative" }}>
											<img style={{ width: "160px", height: "160px", borderRadius: "50%" }} alt="user photo"
												src={userProfile.image || avatarPorDefecto(themeToggle)}
											/>
										</div>
										<b style={{ fontSize: "12px", marginTop: "15px" }}>
											{userProfile.first_name}
											&nbsp;
											{userProfile.last_name}
										</b>
										<div style={{ fontSize: "10px", color: "var(--txt-secondary-color)", width: "75%" }}>
											ID DE USUARIO
										</div>
										<b style={{ fontSize: "12px" }}>
											{userProfile.id}
										</b>
									</div>
									{
										userProfile.currentRole == null ? "" : <div className="card card-default" style={{ padding: "15px" }}>
											<div className="badge rounded-pill bg-primary">{
												(userProfile.currentRole == "student" && "Estudiante")
												|| userProfile.roleMap[userProfile.currentRole].name
											}</div>
											{
												(
													userProfile.roles.length < 1 ||
													(userProfile.student == null && userProfile.roles.length < 2)
												)
													? "" : <button disabled={idleLocked} className="btn btn-default" type="button"
														style={{ color: "var(--txt-main-color)", width: "100%", textAlign: "left", paddingLeft: "20%" }}
														onClick={toggleRoleListDisplay}
													>
														Cambiar rol
													</button>
											}
										</div>
									}
									{
										userProfile.roleMap["superAdmin"] ? "" : <button className="btn" disabled={idleLocked}
											style={{ color: "var(--txt-main-color)", width: "100%", textAlign: "left", paddingLeft: "20%" }}
											type="button" onClick=
											{
												() => {
													setUserProfileOptionsShown(false)
													showUserProfile
														(
															userProfile.currentRole != "student"
																? { ...userProfile, ...userProfile.employee }
																: { ...userProfile, ...userProfile.student }
														)
												}
											}
										>
											Ver perfil
										</button>
									}
									<button style={{ color: "var(--wa-rojo-error)", width: "100%", textAlign: "left", paddingLeft: "20%" }}
										onClick={logout} disabled={idleLocked} className="btn" type="button"
									>
										<FontAwesomeIcon icon={regular("circle-xmark")} />
										&emsp;
										Cerrar sesión
									</button>
								</div>}
							><div className="topNavRightUser"><button className="topNavRightUserImage" disabled={idleLocked}
								type="button" onClick={() => setUserProfileOptionsShown(!userProfileOptionsShown)}
							>
								<img src={userProfile.image || avatarPorDefecto(themeToggle)} style={{ height: "100%" }} alt="user picture" />
							</button></div></Popover></div>
						</div>
					</div>
					{
						!idleLocked ? "" : <div className="loadingBar"><div style={{ padding: "5px 25px" }}>
							<div className="loader0" style={{ borderRadius: "15px" }} />
						</div></div>
					}
				</div>
			}
			<div className="layoutContentMain" style={{ height: "calc(100vh - 59px)", overflowY: "auto", overflowX: "hidden", width: "100vw" }}><Routes><Route
				key={"access"} path={"/access"} element={<Access />}
			/>{
					navigation && navigation.map
						(
							({ path, element: Component }: any) => {
								return <Route key={path} path={"/" + path} element={<PrivateRoute authenticated={authenticated}>
									<Component />
								</PrivateRoute>}
								/>
							}
						)
				}<Route key="*" path="/*" element={<Navigate to={authenticated ? "/" : "/access"} />} /></Routes></div>
		</div></div>
		{
			selectedUserProfile == null ? "" : <UserPrompt promptCloseFn={() => setSelectedUserProfile(null)} UIStatus={UIStatus}
				statusIndex={userProfile.currentRole != "student" ? "employeeStatusRef" : "studentStatusRef"} profileView={true}
				processingError={saveError} selectedUser={selectedUserProfile} allowedUpdate={true} saveSuccess={saveSuccess}
				uneditFn={() => setEditableUserProfile(null)} saveDataFn={saveUserProfile} title="Perfil de usuario"
				employeeView={userProfile.currentRole != "student"} icon={<FontAwesomeIcon icon={solid("id-badge")} />}
				unfilledFields={unfilledFields} dataEditFn=
				{
					() => {
						setEditableUserProfile
							({
								...selectedUserProfile, state_id: selectedUserProfile.city.state_id,
								country_id: selectedUserProfile.city.state.country_id,
								city://Format requirement of the select component
								{
									id: selectedUserProfile.city.id,
									label: selectedUserProfile.city.name
								}
							})
					}
				}
			/>
		}
		{
			!roleListShown ? "" : <Modal appElement={document.getElementById("root") as HTMLElement} className={themes[+themeToggle]}
				style=
				{{
					overlay: { zIndex: 100 },
					content: { height: "min-content", background: "var(--main-bg)", borderRadius: "15px" }
				}} isOpen
			>
				<div style={{ padding: "12px 15px 7px 15px" }}><div style={{ display: "table-row" }}>
					<div style={{ display: "table-cell", color: "var(--txt-color)", paddingTop: "5px", width: "100%" }}>
						Cambiar rol
					</div>
					<div style={{ display: "table-cell" }}><button onClick={toggleRoleListDisplay} type="button"
						disabled={idleLocked || saveSuccess} className="button btn btn-default" style=
						{{
							color: "var(--txt-color)",
							background: "var(--main-bg)",
							borderRadius: "50%",
							width: "40px",
							border: "1px solid var(--wa-filo-2)",
							padding: "2px 0px 0px 2px"
						}}
					>
						<FontAwesomeIcon icon={solid("times")} size="2x" />
					</button></div>
				</div></div>
				<div style={{ width: "100%", padding: "unset", maxHeight: "calc(90vh - 4em)" }}><div
					style={{ padding: "30px 30px 10px", overflowY: "auto" }}
				>
					Rol actual:
					<div className="badge rounded-pill bg-primary">{
						(userProfile.currentRole == "student" && "Estudiante")
						|| userProfile.roleMap[userProfile.currentRole].name
					}</div>
					<br />
					<br />
					{
						userProfile.student == null || userProfile.currentRole == "student" ? "" : <button type="button"
							className="btn btn-outline-dark" onClick={() => changeRole("student")} disabled={idleLocked}
							style={{ display: "table-row", width: "100%" }}
						>
							<span style={{ display: "table-cell", width: "100%" }}>
								Estudiante
							</span>
							<span style={{ display: "table-cell" }}>
								<FontAwesomeIcon icon={solid("chevron-right")} />
							</span>
						</button>
					}
					{
						Object.keys(userProfile.roleMap).filter((key: string) => key != userProfile.currentRole).map
						(
							(key : string, index : number) => <fieldset key={key}>
								<legend>
									<button className="btn btn-outline-dark" disabled={idleLocked}
									  key={"r_" + index} onClick={() => changeRole(key)} style={{ display: "table-row", width: "100%" }}
									>
										<span style={{ display: "table-cell", width: "100%" }}>
											{userProfile.roleMap[key].name}
										</span>
										<span style={{ display: "table-cell" }}>
											<FontAwesomeIcon icon={solid("chevron-right")} />
										</span>
									</button>
								</legend>
								<div>{
									userProfile.roleMap[key].campuses.map
									(
										(campus : any) => <div key={"C_" + campus.id}
										  style={{display : "inline-block", padding : "0px 5px"}}
										>
											<span className="badge" style={{background : "var(--wa-acento)"}}>{
												campus.name
											}</span>
										</div>
									)
								}</div>
							</fieldset>
						)
					}
				</div></div>
			</Modal>
		}
		{
			(commonNotice.heading == null || commonNotice.message == null) ? "" : <Modal className={themes[+themeToggle]}
				style={{ overlay: { zIndex: 100 }, content: { height: "min-content", background: "var(--second-bg)", borderRadius: "15px", boxShadow: "var(--wa-tenue)33 0px 8px 24px" } }}
				appElement={document.getElementById('root') as HTMLElement} isOpen
			>
				<div style={{ padding: "12px 15px 7px 15px" }}><div style={{ display: "table-row" }}>
					<div style={{ display: "table-cell", color: "var(--txt-color)", paddingTop: "5px", width: "100%" }}>
						{commonNotice.heading}
					</div>
					{
						commonNotice.cornerClose != true ? "" : <div style={{ display: "table-cell" }}><button type="button"
							className="button btn btn-default" onClick={() => dispatch(dismissNotice())} style=
							{{
								color: "var(--txt-color)",
								background: "var(--main-bg)",
								borderRadius: "50%",
								width: "35px",
								border: "1px solid var(--wa-filo-2)",
								padding: "2px 0px 0px 2px"
							}}
						>
							<FontAwesomeIcon icon={solid("times")} size="2x" />
						</button></div>
					}
				</div></div>
				<div style={{ padding: "30px", color: "var(--txt-color)" }}>
					{commonNotice.message}
					<br />
					<br />
					<div style={{ textAlign: "right" }}>
						{
							//Con la X arriba y nada que aceptar, el boton de abajo sobra: la X basta (Esteban, 2026-09-29).
							//"Rechazar" solo tiene sentido frente a un "Aceptar".
							(!commonNotice.cornerClose && commonNotice.procedure) || (commonNotice.cornerClose && !commonNotice.procedure) ? "" : <button className="btn btn-dark"
								type="button" onClick=
								{
									() => {
										dispatch(dismissNotice())

										if (commonNotice.optOutProcedure) {
											commonNotice.optOutProcedure()
										}
									}
								}
							>
								{!commonNotice.cornerClose ? "Cerrar" : "Rechazar"}
							</button>
						}
						{
							commonNotice.procedure == null ? "" : <button className="btn btn-light" type="button" onClick=
								{
									() => {
										commonNotice.procedure()
										dispatch(dismissNotice())
									}
								}
							>
								Aceptar
							</button>
						}
					</div>
				</div>
			</Modal>
		}
		<div className="versionInfo" style={{ position: "absolute", bottom: "0px", right: "0px", padding: "5px 10px", color: "var(--wa-negro)" }}>
			<p style={{ margin: "0px" }}>
				{`Versión: ${version}`}
			</p>
		</div>
	</>
}

export default App